var mixins = {
  methods: {
    navigateByAdSettings: function navigateByAdSettings() {
      var performanceInfo = this.performanceInfo;
      var projectServing = performanceInfo.projectServing;
      if (projectServing) {
        var servingType = projectServing.servingType,
          servingURL = projectServing.servingURL;
        if (servingType === 1) {
          // 详情
          var nextDestination = "/myshow/index.html#/detail/".concat(servingURL);
          this.leavePage(nextDestination);
        } else if (servingType === 2) {
          // 魔方
          this.leavePage(servingURL);
        }
      }
    }
  }
};
export default mixins;